import { IBase, ITag, slugify } from "@app/common";

export interface TagFormValues extends Partial<ITag> { }

export const transformStepFormValuesToPayload = (values: Omit<Partial<ITag>, keyof IBase>): Partial<ITag> => {
  return {
    ...values,
    slug: slugify(values.name!)
  }
}